import { render } from "./DeviceTabAlarm.vue?vue&type=template&id=c4684696"
import script from "./DeviceTabAlarm.vue?vue&type=script&lang=js"
export * from "./DeviceTabAlarm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/linuxbasic/GitProjects/caru-platform-api/systems/caru-cloud-platform/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__